import { useTranslation } from 'react-i18next';
import { z } from 'zod';

export const useForgotPasswordSchema = () => {
  const { t } = useTranslation(['validation']);

  return z.object({
    email: z.string().email(t('validation:email')).min(1, t('validation:required')),
  });
};
